import React from 'react';
import { Municipality, getFeesForYear, filterFees, DEFAULT_ENABLED_CATEGORIES } from '@/lib/data';

interface BadgeWidgetProps {
  municipality: Municipality;
  year: number;
  enabledCategories?: string[];
  dark?: boolean;
}

export const BadgeWidget: React.FC<BadgeWidgetProps> = ({ municipality, year, enabledCategories = DEFAULT_ENABLED_CATEGORIES, dark }) => {
  const fees = filterFees(getFeesForYear(municipality, year), enabledCategories);
  const total = fees.reduce((s, f) => s + f.amount, 0);

  return (
    <div
      className={`rounded-xl px-6 py-5 text-center ${
        dark ? 'bg-slate-800' : 'bg-gray-50 border border-gray-100'
      }`}
    >
      <p className={`text-xs uppercase tracking-widest mb-1 ${dark ? 'text-slate-400' : 'text-warmGray'}`}>
        {municipality.name} · {year}
      </p>
      <p className={`text-3xl font-bold tracking-tight ${dark ? 'text-white' : 'text-deepCharcoal'}`}>
        {total.toLocaleString('nb-NO')}
      </p>
      <p className={`text-sm mt-0.5 ${dark ? 'text-slate-400' : 'text-warmGray'}`}>kr/år</p>
    </div>
  );
};
